/**
 * Created by Andrey Popov on 07.04.2025
 */

const OrdersDataSource = function () {
    cleverapps.EventEmitter.call(this);

    cleverapps.eventBus.on("mapEvent", this.onMapEvent.bind(this), this);
    cleverapps.eventBus.on("ordersDataSourceUpdateAll", this.updateAll.bind(this), this);

    Merge2.current.customers.on("onRecipesUpdated", this.reorder.bind(this), this);

    const location = cleverapps.meta.getSelectedLocation();
    if (Merge2.current.bubblesStack) {
        Merge2.current.bubblesStack.on("updateVisible", this.updateAll.bind(this), this);
    }

    location.on("changeStars", this.updateAll.bind(this), this);

    cleverapps.meta.on("progressChanged", this.updateAll.bind(this), this);

    if (cleverapps.weeklyGoals) {
        cleverapps.weeklyGoals.on("updateGoals", this.updateAll.bind(this), this);
    }
};

OrdersDataSource.prototype = Object.create(cleverapps.EventEmitter.prototype);
OrdersDataSource.prototype.constructor = OrdersDataSource;

OrdersDataSource.prototype.updateAll = function () {
    this.trigger("updateAll", true);
};

OrdersDataSource.prototype.getData = function () {
    const rows = [];

    const location = cleverapps.meta.getSelectedLocation();

    if (!location.isLocationCompleted() && location.stars.isEnoughStars()) {
        rows.push(this.createSideBarStyleRow({
            id: "new_task",
            weight: 100010,
            ViewCtor: function () {
                return Prefab.instantiate(bundles.questsgroupicon.jsons.newtaskrow_prefab_json, { source: bundles.questsgroupicon.jsons.newtaskrow_prefab_json });
            }
        }));
    }

    if (Merge2.current.bubblesStack && Merge2.current.bubblesStack.isVisible() && cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
        rows.push(this.createBubbleStackRow());
    }

    if (cleverapps.raveReviews && cleverapps.raveReviews.isAvailable() && cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL) {
        rows.push(this.createRaveReviewRow());
    }

    if (cleverapps.specialEnergyOffer && cleverapps.specialEnergyOffer.getIconLeftTime() > 0) {
        rows.push(this.createSideBarStyleRow({
            id: "special_energy_offer_row",
            weight: 100000,
            ViewCtor: SpecialEnergyOfferRowView
        }));
    }

    [Mission.TYPE_TREASURE_SEARCH, Mission.TYPE_SPACE_RACE, Mission.TYPE_LIGHTNING_RUSH, Mission.TYPE_HUNGRY_GAMES].forEach((missionType) => {
        const mission = cleverapps.missionManager.findRunningMission(missionType);
        const over = mission && mission.logic.isOver && mission.logic.isOver();
        if (mission && mission.isRunning() && !over) {
            rows.push(this.createSideBarStyleRow({
                id: `mission_row_${missionType}`,
                weight: 100000,
                mission,
                ViewCtor: mission.rowView
            }));
        }
    });

    [Mission.TYPE_KINGSCUP, Mission.TYPE_LEVEL_MASTERY, Mission.TYPE_SEASON_PASS, Mission.TYPE_LORYS_DERBY, Mission.TYPE_MERGE2_MISSION].forEach((missionType) => {
        const mission = cleverapps.missionManager.findRunningMission(missionType);
        if (mission && mission.isRunning() && cleverapps.resolution.isVertical()) {
            rows.push(this.createSideBarStyleRow({
                id: `mission_row_${missionType}`,
                weight: 100000,
                mission,
                ViewCtor: mission.rowView
            }));
        }
    });

    if (cleverapps.weeklyGoals && cleverapps.weeklyGoals.isAvailable() && cleverapps.resolution.isVertical()) {
        rows.push(this.createSideBarStyleRow({
            id: "weekly_goals",
            weight: 100002,
            ViewCtor: function () {
                return Prefab.instantiate(bundles.weekly_goals_icon.jsons.weekly_goals_row_prefab_json);
            },
            animations: RecipeIconAnimations
        }));
    }

    Merge2.current.customers.listCustomersWithRecipe()
        .map(this.createRow.bind(this))
        .forEach((row) => {
            rows.push(row);
        });

    return rows;
};

OrdersDataSource.prototype.onMapEvent = function (type) {
    if (type === Field.RECIPE_NEW || type === Field.RECIPE_CHANGE) {
        this.updateAll();
    }
};

OrdersDataSource.prototype.createBubbleStackRow = function () {
    return {
        id: BubblesStack.ID,
        ViewCtor: function (data) {
            return new BubblesStackView(data);
        },
        animations: {
            addRowAnimation: function () {
                return new cc.DelayTime(300);
            },
            removeRowAnimation: function () {
                return new cc.Sequence(new cc.DelayTime(cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? 2 : 0));
            }
        },
        data: Merge2.current.bubblesStack,
        weight: 100011
    };
};

OrdersDataSource.prototype.createRaveReviewRow = function () {
    return {
        id: "rave_review",
        ViewCtor: RaveReviewsRowView,
        data: cleverapps.raveReviews,
        weight: 100001
    };
};

OrdersDataSource.prototype.createSideBarStyleRow = function (data) {
    return {
        id: data.id,
        ViewCtor: data.ViewCtor,
        animations: RecipeIconAnimations,
        weight: data.weight,
        data
    };
};

OrdersDataSource.prototype.createRow = function (customer) {
    return {
        id: customer.recipe.index,
        weight: this.calcOrderWeight(customer.recipe),
        animations: RecipeIconAnimations,
        data: customer
    };
};

OrdersDataSource.prototype.calcOrderWeight = function (recipe) {
    if (recipe.sideQuest) {
        return recipe.isEnoughIngredients() ? OrdersDataSource.WEIGHTS.READY - 1 : -1;
    }

    let weight = 0;
    if (recipe.eventOrder) {
        weight = OrdersDataSource.WEIGHTS.EVENT;
    } else if (recipe.isEnoughIngredients()) {
        weight = OrdersDataSource.WEIGHTS.READY;
    } else if (recipe.getIngredients().some((ingredient) => ingredient.amount <= Merge2.current.stock.getStockAmount(ingredient))) {
        weight = OrdersDataSource.WEIGHTS.PARTIAL;
    }

    return weight;
};

OrdersDataSource.prototype.reorder = function () {
    this.trigger("reorder");
};

OrdersDataSource.prototype.destructor = function () {
    runCleaners(this); 
};

OrdersDataSource.WEIGHTS = {
    EVENT: 30,
    READY: 20,
    PARTIAL: 10
};